<template>
	<a-row class="searchBox">
		<a-col :span='24' class="titleBox">
			<a-col :span='4' class="left">查询条件</a-col>
			<a-col :span='20' class="right">
				<a-button type="primary" class="btn" @click="onSearch()">查询</a-button>
				<a-button type="default" class="btn" @click="onReset()">重置</a-button>
			</a-col>
		</a-col>
		<a-col :span="24">
			<a-form-model ref="ruleForm" :model="searchForm" :rules="rules">
				<template v-for="(item, index) in searchList">
					<a-col :span='6' :key="index">
						<a-form-model-item :label="item.label" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }" :prop="item.model">
							<a-input v-if="item.type == 'text'" v-model="searchForm[item.model]" :placeholder="`请输入${item.label}`"></a-input>
							<a-date-picker v-if="item.type == 'date'" v-model="searchForm[item.model]" :placeholder="`请选择${item.label}`" format="YYYY/MM/DD" :prop="item.model" />
							<a-select v-if="item.type == 'select'" v-model="searchForm[item.model]" :placeholder="`请选择${item.label}`" :prop="item.model" style="width: 100%;">
								<template v-for="option in item.options">
									<a-select-option :key="option.val" :label="option.txt" :value="option.txt">{{ option.txt }}</a-select-option>
								</template>
							</a-select>
						</a-form-model-item>
					</a-col>
				</template>
			</a-form-model>
		</a-col>
	</a-row>
</template>

<script>
	import PolicyConditions from '@/policies/policy-conditions.js';
	export default {
        props: {
            reportKey: {
                type: String,
                default: ""
            }
        },
		watch: {
			searchForm: {
				handler: "listenSearchForm",
				deep: true
            }
		},
		data() {
			return {
				searchList: [],
				searchForm: {},
				rules: {}
			}
		},
		methods: {
			// 更新搜索模块
			initForm() {
				const {
					searchList,
					searchForm,
					rules
				} = PolicyConditions.get({
					reportKey: this.reportKey
				});
				this.searchList = searchList;
				this.searchForm = searchForm;
				this.rules = rules;
				this.listenSearchForm();
			},
			// 初始化、监听表单值变化
			listenSearchForm() {
				const filters = this.searchList.map(ele => {
					return {
						eq: ele.eq,
						label: ele.label,
						model: ele.model,
						value: ele.type.includes("date") && this.searchForm[ele.model] ? this.$formatDate(this.searchForm[ele.model]._d) : this.searchForm[ele.model]
					}
				}).filter(e => e.value)
				this.$store.commit("SETREPORTSEARCHFILTER", filters)
			},
			// 搜索
			onSearch() {
				this.$root.$bus.$emit("QueryReport")
			},
			// 重置
			onReset() {
				this.$refs.ruleForm.resetFields();
				this.$store.commit("SETREPORTSEARCHFILTER", false)
				this.$root.$bus.$emit("ResetReport")
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.searchBox {
		border: 1px solid #bfcbd9;
		padding: 16px;
		border-radius: 5px;
		.titleBox {
			padding-bottom: 10px;
			border-bottom: 1px dashed #bfcbd9;
			margin-bottom: 15px;
			.left {}
			.right {
				text-align: right;
				.btn {
					width: 120px;
					margin-left: 16px;
				}
			}
		}
	}
</style>